import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import DeleteCancel from '../../atoms/buttons/DeleteCancel'
import { deleteBackup } from "../../../store/blueprint/actions";



export default function DeleteBlueprintBackup({ deletePayload, onClose, onCompletion }) {

    const dispatch = useDispatch();
    const [deleteInProgress, setDeleteInProgress] = useState(false)

    const onDelete = async () => {
        setDeleteInProgress(true)
        
        let backupIds = []
        let blueprintId = ""
        if(Array.isArray(deletePayload)){
            deletePayload.forEach(item => {
                blueprintId = item.blueprintId;
                backupIds.push(item._id)
            })
        }else{
            backupIds.push(deletePayload?._id)
        }
        // console.log({backupIds})

        const payload = { 
            blueprintId: deletePayload != undefined ? deletePayload.blueprintId : blueprintId,
            backupIds,    
        };

        // console.log({payload})

        dispatch(deleteBackup(payload)).then(result => {
            if (result.status == false) {
                setDeleteInProgress(false)
            }
            onCompletion(result);
        })
        onClose();

    }

    return (
        <Grid id={"delete_backup_modal"} container direction={"row"} spacing={2} >
            <Grid item xs={12}>
                <Typography variant="h6" >Delete</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider/>
            </Grid>
            <Grid item xs={12}>
                <Typography> Are you sure you want to delete the backup ? </Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider/>
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel disableButton={deleteInProgress} onDelete={onDelete} onCancel={onClose} />
            </Grid>
        </Grid>


    )
}